'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('antd/lib/layout');

var _layout2 = _interopRequireDefault(_layout);

var _AdminBreadcrumb = require('../components/AdminBreadcrumb');

var _AdminBreadcrumb2 = _interopRequireDefault(_AdminBreadcrumb);

var _AdminMenu = require('../components/AdminMenu');

var _AdminMenu2 = _interopRequireDefault(_AdminMenu);

var _AdminMenuFooter = require('../components/AdminMenuFooter');

var _AdminMenuFooter2 = _interopRequireDefault(_AdminMenuFooter);

var _AdminFooter = require('../components/AdminFooter');

var _AdminFooter2 = _interopRequireDefault(_AdminFooter);

var _reduxRegexpRouter = require('redux-regexp-router');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Icon from 'antd/lib/icon';


var Content = _layout2.default.Content,
    Footer = _layout2.default.Footer,
    Sider = _layout2.default.Sider;


var styles = {
    layout: { height: '100vh' },
    sider: {
        overflow: 'auto'
    },
    content: {
        margin: '0 16px',
        overflow: 'initial'
    },
    children: { padding: '0 0 30px', background: '#fff' },
    footer: { textAlign: 'center' }
};

var AdminLayout = function (_React$Component) {
    _inherits(AdminLayout, _React$Component);

    function AdminLayout() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AdminLayout);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AdminLayout.__proto__ || Object.getPrototypeOf(AdminLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            collapsed: false,
            mode: 'inline'
        }, _this.onCollapse = function (collapsed) {
            _this.setState({
                collapsed: collapsed,
                mode: collapsed ? 'vertical' : 'inline'
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AdminLayout, [{
        key: 'render',
        value: function render() {
            var collapsed = this.state.collapsed;

            return _react2.default.createElement(
                _layout2.default,
                { style: styles.layout },
                _react2.default.createElement(
                    Sider,
                    {
                        collapsible: true,
                        collapsed: collapsed,
                        onCollapse: this.onCollapse,
                        style: styles.sider
                    },
                    _react2.default.createElement('div', { className: 'logo' }),
                    _react2.default.createElement(_AdminMenu2.default, {
                        collapsed: collapsed
                    }),
                    _react2.default.createElement(_AdminMenuFooter2.default, null)
                ),
                _react2.default.createElement(
                    _layout2.default,
                    null,
                    _react2.default.createElement(
                        Content,
                        { style: styles.content },
                        _react2.default.createElement(_AdminBreadcrumb2.default, null),
                        _react2.default.createElement(
                            'div',
                            { style: styles.children, className: 'contentWrapper' },
                            this.props.children
                        )
                    ),
                    _react2.default.createElement(
                        Footer,
                        { style: styles.footer },
                        _react2.default.createElement(_AdminFooter2.default, null)
                    )
                )
            );
        }
    }]);

    return AdminLayout;
}(_react2.default.Component);

// addRoutingContext(AdminLayout);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.user,
        config: state.config,
        routing: state.routing
    };
})(AdminLayout);
//# sourceMappingURL=AdminLayout.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/containers/AdminLayout.js
// module id = 1279
// module chunks = 5